@if (enquiryFlight?.airportDepartId) {
  <div [class.card]="!clickable" [class.mb-4]="!clickable">
    <div [class.card-body]="!clickable">
      <div class="row justify-content-center text-center">
        <div class="col-lg-4">
          <fa-icon [icon]="faPlaneDeparture"></fa-icon>
          <div
            class="airport-iata-code"
            [innerText]="enquiryFlight.airportDepartIataCode"
          ></div>
          @if (airportsObj[enquiryFlight.airportDepartId]?.icaoCode) {
            <div class="airport-icao-code">
              ICAO: {{ airportsObj[enquiryFlight.airportDepartId]?.icaoCode }}
            </div>
          }
          {{ enquiryFlight.airportDepartTitle }}<br />
          {{ enquiryFlight.departDateLocal | date : "EE dd MMM yyyy" : undefined : "fr"
          }}<br />
          {{ enquiryFlight.departTimeLocal }} <strong>LT</strong>
          {{ enquiryFlight.departTimeUtc }} <strong>UTC</strong>
        </div>
        @if (enquiryFlight.airportArrivalId) {
          <div class="col-lg-4">
            <div class="d-flex justify-content-center align-items-center flex-column h-100">
              <fa-icon [icon]="faClock"></fa-icon>
              @if (getEnquiryFlightFlyTimeInMin(enquiryFlight) > 0) {
                <div
                  class="text-muted"
                        [innerText]="
                            convertMinutesToTime(
                                getEnquiryFlightFlyTimeInMin(enquiryFlight),
                                'h ',
                                'min'
                            )
                        "
                ></div>
              }
              @if (getEnquiryFlightFlyTimeInMin(enquiryFlight) < 0) {
                <div
                  class="alert alert-danger text-center"
                  >
                  Le temps de vol est impossible à calculer. Vérifiez les heures de départ et
                  arrivée.
                </div>
              }
              @if (getEnquiryFlightFlyTimeInMin(enquiryFlight) === 0) {
                <div
                  class="text-muted"
                  >
                  x h x min
                </div>
              }
            </div>
          </div>
        }
        @if (enquiryFlight.airportArrivalId) {
          <div class="col-lg-4">
            <fa-icon [icon]="faPlaneArrival"></fa-icon>
            <div
              class="airport-iata-code"
              [innerText]="enquiryFlight.airportArrivalIataCode"
            ></div>
            @if (airportsObj[enquiryFlight.airportArrivalId]?.icaoCode) {
              <div class="airport-icao-code">
                ICAO: {{ airportsObj[enquiryFlight.airportArrivalId]?.icaoCode }}
              </div>
            }
            {{ enquiryFlight.airportArrivalTitle }}<br />
            @if (enquiryFlight.departDateTimeUtc === enquiryFlight.arrivalDateTimeUtc) {
              <span
                class="text-muted"
                [innerText]="'ENQUIRY_FLIGHTS.ARRIVAL_DATE_TIME_TBD' | translate"></span
                >
              }
              @if (enquiryFlight.departDateTimeUtc !== enquiryFlight.arrivalDateTimeUtc) {
                {{ enquiryFlight.arrivalDateLocal | date : "EE dd MMM yyyy" : undefined : "fr"
                }}<br />
                {{ enquiryFlight.arrivalTimeLocal }} <strong>LT</strong>
                {{ enquiryFlight.arrivalTimeUtc }} <strong>UTC</strong>
              }
              @if (enquiryFlight.isAircraftGroundedOnArrival) {
                <div [innerText]="'CALENDAR.GROUNDED_ON_ARRIVAL' | translate"></div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
